import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AlainThemeModule } from '@delon/theme';
import { DelonACLModule } from '@delon/acl';
import { DelonFormModule } from '@delon/form';
import { SHARED_DELON_MODULES } from './shared-delon.module';
import { SHARED_ZORRO_MODULES } from './shared-zorro.module';
import { StColFilterPipe } from './utils/st-col-filter.pipe';
import { OptFilterPipe } from './utils/opt-filter.pipe';
import { OptinFilterPipe } from './utils/optin-filter.pipe';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { ContentSelectorComponent } from '../routes/publish/component/content-selector.component';
import { DeviceSelectorComponent } from '../routes/publish/component/device-selector.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { AuditRemarkComponent } from '../routes/publish/component/audit-remark.component';

// #region third libs

const THIRDMODULES: Type<any>[] = [];

// #endregion

// #region your componets & directives

const COMPONENTS: Type<any>[] = [ContentSelectorComponent, DeviceSelectorComponent, AuditRemarkComponent];
const DIRECTIVES: Type<any>[] = [];
const Pipes: Type<any>[] = [StColFilterPipe, OptFilterPipe, OptinFilterPipe];

// #endregion

@NgModule({
  imports: [
    NzTagModule,
    NzTimelineModule,
    NzDatePickerModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlainThemeModule.forChild(),
    DelonACLModule,
    DelonFormModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    // third libs
    ...THIRDMODULES,
    NzTreeModule,
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
    ...Pipes,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlainThemeModule,
    DelonACLModule,
    DelonFormModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    // third libs
    ...THIRDMODULES,
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
    ...Pipes,
  ],
})
export class SharedModule {}
